import styled from "@emotion/styled";

// this `objectFit` prop is important in order to keep the img proportion as expected
export const StyledThumbnail = styled.img({
    objectFit: "cover",
});
